import { render, staticRenderFns } from "./CardStyle1.vue?vue&type=template&id=08a9b842&scoped=true&"
import script from "./CardStyle1.vue?vue&type=script&lang=js&"
export * from "./CardStyle1.vue?vue&type=script&lang=js&"
import style0 from "./CardStyle1.vue?vue&type=style&index=0&id=08a9b842&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a9b842",
  null
  
)

export default component.exports